import React from 'react';
import { metrics } from '@atlassian/browser-metrics';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';

const opsgenieSchedulePageLoad = metrics.pageLoad({
	key: 'software.opsgenie-schedule',
	ssr: {
		doneAsFmp: false,
	},
	slo: {
		tti: {
			initial: { threshold: 4000 },
			transition: { threshold: 4000 },
		},
	},
});

export const PerformanceTracker = () => (
	<JSErrorBoundary
		fallback="unmount"
		packageName="jiraOpsgenieSchedule"
		teamName="fusion-solaris"
		id="performanceTracker"
	>
		<SubmitApdex
			appName="jira-opsgenie-schedule"
			// @ts-expect-error - TS2769 - No overload matches this call. Looks like platform component types are not matched
			metric={opsgenieSchedulePageLoad}
		/>
	</JSErrorBoundary>
);
